/**
 * EOL stage cards show a fixed grey prefix before the user-entered title.
 * Prefix depends on the release phase / stage name — not a single "EOL:" for all.
 */

const EOL_PHASE_PREFIX_BY_NORMALIZED_NAME: Record<string, string> = {
  'initial announcement': 'EOL:',
  'end of sale': 'EOSa:',
  'end of support': 'EOSu:',
  decommission: 'Decom:',
  decommision: 'Decom:'
};

/** Matches any EOL stage prefix the UI may have stored or displayed. */
const EOL_STAGE_PREFIX_PATTERN = /^(?:(?:EOL|EOSa|EOSu|Decom):\s*)+/i;

function normalizeEolPhaseKey(phaseName?: string | null): string {
  return (phaseName ?? '').trim().toLowerCase();
}

/** Prefix label for an EOL release phase (defaults to EOL: when phase unknown). */
export function getEolPhaseTitlePrefix(phaseName?: string | null): string {
  const key = normalizeEolPhaseKey(phaseName);
  if (key && EOL_PHASE_PREFIX_BY_NORMALIZED_NAME[key]) {
    return EOL_PHASE_PREFIX_BY_NORMALIZED_NAME[key];
  }
  return 'EOL:';
}

/** Remove any EOL stage prefix from a stored or display title. */
export function stripEolPhaseNamePrefix(
  name: string | undefined | null
): string {
  if (name == null) return '';
  return String(name).replace(EOL_STAGE_PREFIX_PATTERN, '').trim();
}

/** Full display title: "{prefix} {userTitle}" with prefix from phase name. */
export function formatEolPhaseDisplayTitle(
  phaseName: string | undefined | null,
  title: string | undefined | null
): string {
  const bare = stripEolPhaseNamePrefix(title ?? '');
  const prefix = getEolPhaseTitlePrefix(phaseName);
  return bare ? `${prefix} ${bare}` : prefix.trim();
}

/** @deprecated Use {@link stripEolPhaseNamePrefix} — kept for existing imports. */
export function stripEolNamePrefix(name: string): string {
  return stripEolPhaseNamePrefix(name);
}
